import { createContext, useCallback, useContext, useState } from "react";

// Single source of truth for the tickets overlay so any CTA on any
// page can pop the same iframe modal without drilling props through.
const TicketsContext = createContext({
  isOpen: false,
  open: () => {},
  close: () => {},
});

export function TicketsProvider({ children }) {
  const [isOpen, setOpen] = useState(false);
  const open = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);
  return (
    <TicketsContext.Provider value={{ isOpen, open, close }}>
      {children}
    </TicketsContext.Provider>
  );
}

export const useTickets = () => useContext(TicketsContext);
